import React from 'react';
export function LoadingSpinner() {
  return <div className="flex items-center justify-center min-h-screen bg-gray-50" data-id="element-5419" data-mp="2n4y3d085l7hb">
      <div className="flex flex-col items-center" data-id="element-5420" data-mp="2s8p9j47t4l39">
        <div className="w-12 h-12 border-4 border-[#1E2B55] border-t-transparent rounded-full animate-spin" data-id="element-5421" data-mp="2dldwexvz8t11"></div>
        <p className="mt-4 text-gray-600 text-sm" data-id="element-5422" data-mp="2ijnqf55ytnl2">Loading...</p>
      </div>
    </div>;
}